export function formatCurrency(n) {
  const v = Number(n || 0);
  return v.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
}

// Format US phone numbers as (XXX)XXX-XXXX. Leaves unrecognized values unchanged.
export function formatPhone(v) {
  if (v === null || v === undefined || v === "") return v;
  let digits = String(v).replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("1")) digits = digits.slice(1);
  if (digits.length !== 10) return String(v);
  return `+1 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

// Progressive input formatter → (XXX)XXX-XXXX. Use on phone text fields as the user types.
export function formatPhoneInput(v) {
  let d = String(v ?? "").replace(/\D/g, "");
  if (d.length === 11 && d.startsWith("1")) d = d.slice(1);
  d = d.slice(0, 10);
  if (d.length === 0) return "";
  if (d.length < 4) return `(${d}`;
  if (d.length < 7) return `(${d.slice(0, 3)})${d.slice(3)}`;
  return `(${d.slice(0, 3)})${d.slice(3, 6)}-${d.slice(6)}`;
}

export function isPhoneKey(key = "") {
  const k = String(key).toLowerCase();
  if (k.includes("consent") || k.includes("line_type") || k.includes("carrier")) return false;
  return k.includes("phone") || k === "mobile" || k === "fax";
}

// Type prefixes for human-friendly record IDs — three letters + 4-digit number (e.g. PLN-3848).
export const RECORD_PREFIX = {
  leads: "ANL",            // Analysis
  inbound_leads: "LED",    // Lead
  property_search: "PRP",  // Property Search
  projects: "PRJ",         // Project
  acquisition: "ACQ",      // Acquisition
  acquisition_pipeline: "ACQ", // Acquisition deal
  planning: "PLN",         // Planning
  opportunities: "DSN",    // Design
  preconstruction: "PRE",  // Preconstruction
  construction: "CON",     // Construction
  closeout: "CLO",         // Closeout
  accounts: "ACC",
  contacts: "CNT",
  trials: "TRL",
  campaigns: "CMP",
  audiences: "AUD",
  content_assets: "AST",
  tasks: "TSK",
  notes: "NOT",
  message_templates: "TPL",
  work_items: "WRK",
};

// Format a record number with its type prefix, e.g. formatRecordId("planning", 3848) -> "PLN-3848".
export function formatRecordId(resource, recordNo) {
  if (recordNo === null || recordNo === undefined || recordNo === "") return "";
  const prefix = RECORD_PREFIX[resource] || "REC";
  return `${prefix}-${String(recordNo).padStart(4, "0")}`;
}



export function formatDate(s) {
  if (!s) return "—";
  const m = typeof s === "string" && s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  const d = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(s);
  if (isNaN(d)) return "—";
  return d.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
}

export function formatDateTime(s) {
  if (!s) return "—";
  const d = new Date(s);
  if (isNaN(d)) return "—";
  return d.toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
}

export function initials(name = "") {
  return name.split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();
}

const GREEN = "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300 border-emerald-200 dark:border-emerald-800";
const RED = "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300 border-red-200 dark:border-red-800";
const AMBER = "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300 border-amber-200 dark:border-amber-800";
const BLUE = "bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-300 border-sky-200 dark:border-sky-800";
const PURPLE = "bg-violet-100 text-violet-800 dark:bg-violet-900/40 dark:text-violet-300 border-violet-200 dark:border-violet-800";
const GRAY = "bg-muted text-muted-foreground border-border";

const MAP = {
  Active: GREEN, Won: GREEN, "Closed Won": GREEN, Converted: GREEN, Connected: GREEN,
  Qualified: GREEN, Completed: GREEN, Approved: GREEN, Published: GREEN, Positive: GREEN, Hot: RED,
  Lost: RED, "Closed Lost": RED, Cancelled: RED, Churned: RED, Disqualified: RED, "At Risk": RED,
  "No Show": RED, Negative: RED, "Past Due": RED, Expired: RED,
  Pending: AMBER, "Pending Approval": AMBER, Scheduled: AMBER, Paused: AMBER, Warm: AMBER,
  "In Progress": AMBER, "In Review": AMBER, Nurture: AMBER, Draft: GRAY, Onboarding: BLUE,
  New: BLUE, Engaged: BLUE, "Attempting Contact": AMBER, "Demo Scheduled": PURPLE, "Demo Completed": PURPLE,
  "Trial Started": PURPLE, Neutral: GRAY, Cold: BLUE, "To Do": GRAY, Requested: AMBER,
  Confirmed: BLUE, Disconnected: GRAY,
  Delivered: GREEN, Sent: BLUE, Opened: GREEN, Read: GREEN, Received: BLUE,
  Failed: RED, Bounced: RED, Spam: RED, Undelivered: RED, Logged: GRAY,
};

export function statusColor(status) {
  return MAP[status] || GRAY;
}
